import './InvisibleCaptcha.eecaef1c10a53d2de1dd88193fb56fba.css';
export default {"primaryColor":"var(--color-primary, #579eb0)","successColor":"#007420","errorColor":"#c00"};